export default __webpack_public_path__ + "static/100--stacked-area-bffd29cb6784ed51a9cb34b0a4934335.png";